import { ApolloProvider } from "react-apollo";
import client from "../../config/apollo";
;

export default function ApolloSetup({ children }) {
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
}
